module.exports = __webpack_public_path__ + "static/media/create-your-story.528b6315.png";